import { render } from "./ImmaginiRapportino.vue?vue&type=template&id=b13df1ec&scoped=true"
import script from "./ImmaginiRapportino.vue?vue&type=script&lang=js"
export * from "./ImmaginiRapportino.vue?vue&type=script&lang=js"

import "./ImmaginiRapportino.vue?vue&type=style&index=0&id=b13df1ec&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_entasys/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b13df1ec"]])

export default __exports__